//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const QuestionFilled = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="QuestionFilled"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_21719_60)">
            <path
              d="M8.00001 6.26624e-06C6.94906 -0.00130988 5.90818 0.204718 4.93698 0.606289C3.96578 1.00786 3.08335 1.59709 2.34022 2.34022C1.59709 3.08335 1.00786 3.96578 0.606289 4.93698C0.204718 5.90818 -0.00130988 6.94906 6.26624e-06 8.00001C6.26624e-06 10.1217 0.842861 12.1566 2.34315 13.6569C3.84344 15.1572 5.87827 16 8.00001 16C10.1217 16 12.1566 15.1572 13.6569 13.6569C15.1572 12.1566 16 10.1217 16 8.00001C16 3.57401 12.426 6.26624e-06 8.00001 6.26624e-06ZM7.78701 13.724C7.18301 13.724 6.70201 13.244 6.70201 12.639C6.70201 12.035 7.18201 11.555 7.78701 11.555C8.07436 11.5563 8.34957 11.6711 8.55276 11.8742C8.75596 12.0774 8.87069 12.3527 8.87201 12.64C8.87101 13.244 8.39101 13.724 7.78701 13.724ZM9.51001 8.16001C9.03001 8.65801 8.69201 9.03001 8.69201 9.84901C8.69095 10.0891 8.59502 10.3191 8.42513 10.4888C8.25523 10.6585 8.02514 10.7542 7.78501 10.755C7.54487 10.7542 7.31478 10.6585 7.14489 10.4888C6.97499 10.3191 6.87906 10.0891 6.87801 9.84901C6.87801 8.30201 7.62501 7.50201 8.17601 6.91501C8.65601 6.40001 8.88701 6.13301 8.88701 5.54601C8.88701 4.94201 8.38901 4.44401 7.78501 4.44401C7.18101 4.44401 6.68301 4.94201 6.68301 5.54601C6.68222 5.78631 6.5864 6.01655 6.41648 6.18648C6.24655 6.3564 6.01631 6.45222 5.77601 6.45301C5.5357 6.45222 5.30546 6.3564 5.13553 6.18648C4.96561 6.01655 4.8698 5.78631 4.86901 5.54601C4.88885 4.79059 5.20289 4.07278 5.7442 3.5455C6.28552 3.01822 7.01133 2.72314 7.76701 2.72314C8.52268 2.72314 9.2485 3.01822 9.78981 3.5455C10.3311 4.07278 10.6452 4.79059 10.665 5.54601C10.701 6.88001 10.043 7.59101 9.51001 8.16001Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_21719_60">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
